module.exports = __webpack_public_path__ + "img/miniapp.7f2fcc80.svg";